import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { Theme } from '@routific/hive';

interface Row {
  index: string;
  key: ReactNode;
  value: ReactNode;
}

interface Props {
  rows: Row[]
}

const TableElement = styled.table`
  td {
    .ant-typography {
      white-space: nowrap;
    }
    &:first-child {
      padding-right: ${Theme.Spacing.smSpacing}
    }
  }
`;

const TooltipTable: React.FC<Props> = ({
  rows,
}) => (
  <TableElement cellSpacing={0} cellPadding={0}>
    <tbody>
      {rows.map((row: Row) => (
        <tr key={row.index}>
          <td>{row.key}</td>
          <td>{row.value}</td>
        </tr>
      ))}
    </tbody>
  </TableElement>
);

export default TooltipTable;
